import React, {  useRef } from "react";

import "./styles/widget-carousel.scss";
import { Carousel } from "antd";
import { GCPENDPOINT } from "../../../constant/common";

import { ReactComponent as LeftArrow } from "../../../assets/svg/arrow-left-circle-outline.svg";
import { ReactComponent as RightArrow } from "../../../assets/svg/arrow-right-circle-outline.svg";

const WidgetCarousel: React.FC<any> = ({ screenshots }): JSX.Element => {
  const ref = useRef<string | any>();

  const onClick = (type: string) => {
    if (type === "PREV") {
      ref.current.prev();
    }
    if (type === "NEXT") {
      ref.current.next();
    }
  };


  return (
      <div className="carousel-gallery">
        <span data-test-id="prev_button" className="prev-button" onClick={() => onClick("PREV")}>
          <LeftArrow />
        </span>
        <Carousel ref={ref} slidesPerRow={4}>
          {screenshots.map((img: string, index: number) => (
            <div key={index} className="ant-modal-body" >
              <img data-test-id={`${index}`} className="carousel-image" src={`${img.startsWith("https://" ? img : GCPENDPOINT+img)}`} alt="card-title" />
            </div>
          ))}
        </Carousel>
        <span data-test-id="next_button" className="next-button" onClick={() => onClick("NEXT")}>
          <RightArrow />
        </span>
      </div>
  );
};
export default WidgetCarousel;
